import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n          Pre Employment Checks\n        ", -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", { class: "text-red-500 mt-4" }, "\n              For those working on HM Courts, ALL will require a specific HM\n              Courts British Standard (BPSS) Check which will include a\n              Disclosure Check as part of the British Standard.\n            "),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("p", { class: "text-red-500 mt-4" }, [
        /*#__PURE__*/ _createTextVNode("\n              Therefore please do "),
        /*#__PURE__*/ _createElementVNode("span", { class: "underline" }, "not"),
        /*#__PURE__*/ _createTextVNode(" select that\n              a Disclosure Check is required within the box below as this would\n              indicate a separate Disclosure Check is required.\n            ")
    ])
], -1);
const _hoisted_6 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Is a Disclosure Check Required? *")
], -1);
const _hoisted_8 = { class: "mt-4 space-y-4" };
const _hoisted_9 = { class: "flex items-start" };
const _hoisted_10 = { class: "h-5 flex items-center" };
const _hoisted_11 = ["checked", "disabled"];
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "disclosure-check-no",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_13 = { class: "flex items-start" };
const _hoisted_14 = { class: "h-5 flex items-center" };
const _hoisted_15 = ["checked", "disabled"];
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "disclosure-check-yes",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_17 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_18 = {
    key: 0,
    class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4"
};
const _hoisted_19 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, [
        /*#__PURE__*/ _createTextVNode("\n                  If Disclosure and Barring Scheme (DBS) -\n                  "),
        /*#__PURE__*/ _createElementVNode("span", { class: "extra-bold" }, "England"),
        /*#__PURE__*/ _createTextVNode(" and\n                  "),
        /*#__PURE__*/ _createElementVNode("span", { class: "extra-bold" }, "Wales"),
        /*#__PURE__*/ _createTextVNode(" Only\n                ")
    ])
], -1);
const _hoisted_21 = { class: "mt-4 space-y-4" };
const _hoisted_22 = { class: "flex items-start" };
const _hoisted_23 = { class: "h-5 flex items-center" };
const _hoisted_24 = ["disabled", "checked"];
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "disclosureSchemeEnglandWales",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "DBS Basic")
], -1);
const _hoisted_26 = { class: "flex items-start" };
const _hoisted_27 = { class: "h-5 flex items-center" };
const _hoisted_28 = ["checked", "disabled"];
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "disclosureSchemeEnglandWales",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "DBS Standard")
], -1);
const _hoisted_30 = { class: "flex items-start" };
const _hoisted_31 = { class: "h-5 flex items-center" };
const _hoisted_32 = ["checked", "disabled"];
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "dbs-enhanced",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "DBS Enhanced with Barred Lists")
], -1);
const _hoisted_34 = {
    key: 1,
    class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4"
};
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, [
        /*#__PURE__*/ _createTextVNode("\n                  If Disclosure Scotland (DS) -\n                  "),
        /*#__PURE__*/ _createElementVNode("span", { class: "extra-bold" }, "Scotland"),
        /*#__PURE__*/ _createTextVNode(" Only\n                ")
    ])
], -1);
const _hoisted_36 = { class: "mt-4 space-y-4" };
const _hoisted_37 = { class: "flex items-start" };
const _hoisted_38 = { class: "h-5 flex items-center" };
const _hoisted_39 = ["disabled", "checked"];
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "ds-basic",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "DS Basic")
], -1);
const _hoisted_41 = { class: "flex items-start" };
const _hoisted_42 = { class: "h-5 flex items-center" };
const _hoisted_43 = ["disabled", "checked"];
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "disclosureSchemeScotland",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "DS Standard")
], -1);
const _hoisted_45 = { class: "flex items-start" };
const _hoisted_46 = { class: "h-5 flex items-center" };
const _hoisted_47 = ["disabled", "checked"];
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "disclosureSchemeScotland",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "DS Enhanced")
], -1);
const _hoisted_49 = { class: "flex items-start" };
const _hoisted_50 = { class: "h-5 flex items-center" };
const _hoisted_51 = ["disabled", "checked"];
const _hoisted_52 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "disclosureSchemeScotland",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "DS PVG")
], -1);
const _hoisted_53 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_54 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _hoisted_5,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("fieldset", null, [
                            _hoisted_7,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("input", {
                                            id: "radio-button-disclosure-check-no",
                                            name: "disclosureCheckRequired",
                                            type: "radio",
                                            value: "No",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                }]),
                                            checked: _ctx.formData.disclosureCheckRequired === 'No',
                                            disabled: _ctx.showApprovalSteps,
                                            onChange: _cache[0] || (_cache[0] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.disclosureCheckRequired.$touch()))
                                        }, null, 42, _hoisted_11)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_12
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("input", {
                                            id: "radio-button-disclosure-check-yes",
                                            name: "disclosureCheckRequired",
                                            type: "radio",
                                            value: "Yes",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                }]),
                                            checked: _ctx.formData.disclosureCheckRequired === 'Yes',
                                            disabled: _ctx.showApprovalSteps,
                                            onChange: _cache[2] || (_cache[2] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.disclosureCheckRequired.$touch()))
                                        }, null, 42, _hoisted_15)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_16
                                ]),
                                _createTextVNode(),
                                (_ctx.v$.formData.disclosureCheckRequired.$errors.length)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "\n                  *\n                  " + _toDisplayString(_ctx.v$.formData.disclosureCheckRequired.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.formData.disclosureCheckRequired === 'Yes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("fieldset", null, [
                                (_ctx.v$.formData.disclosureSchemeEnglandWales.$errors.length ||
                                    _ctx.v$.formData.disclosureSchemeScotland.$errors.length)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "\n                *\n                " + _toDisplayString(_ctx.v$.formData.disclosureSchemeEnglandWales.$errors[0]
                                        .$message ??
                                        _ctx.v$.formData.disclosureSchemeScotland.$errors[0].$message), 1))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                _hoisted_20,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("input", {
                                                id: "radio-button-dbs-basic",
                                                name: "disclosureSchemeEnglandWales",
                                                type: "radio",
                                                value: "DBS Basic",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.disclosureSchemeEnglandWales === 'DBS Basic',
                                                onChange: _cache[4] || (_cache[4] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.disclosureSchemeEnglandWales.$touch()))
                                            }, null, 42, _hoisted_24)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_25
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("div", _hoisted_27, [
                                            _createElementVNode("input", {
                                                id: "radio-button-dbs-standard",
                                                name: "disclosureSchemeEnglandWales",
                                                type: "radio",
                                                value: "DBS Standard",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                checked: _ctx.formData.disclosureSchemeEnglandWales === 'DBS Standard',
                                                disabled: _ctx.showApprovalSteps,
                                                onChange: _cache[6] || (_cache[6] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.disclosureSchemeEnglandWales.$touch()))
                                            }, null, 42, _hoisted_28)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_29
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_30, [
                                        _createElementVNode("div", _hoisted_31, [
                                            _createElementVNode("input", {
                                                id: "radio-button-dbs-enhanced",
                                                name: "disclosureSchemeEnglandWales",
                                                type: "radio",
                                                value: "DBS Enhanced with Barred Lists",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                checked: _ctx.formData.disclosureSchemeEnglandWales ===
                                                    'DBS Enhanced with Barred Lists',
                                                disabled: _ctx.showApprovalSteps,
                                                onChange: _cache[8] || (_cache[8] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.disclosureSchemeEnglandWales.$touch()))
                                            }, null, 42, _hoisted_32)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_33
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    (_ctx.formData.disclosureCheckRequired === 'Yes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("fieldset", null, [
                                _hoisted_35,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                            _createElementVNode("input", {
                                                id: "radio-button-ds-basic",
                                                name: "disclosureSchemeScotland",
                                                type: "radio",
                                                value: "DS Basic",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.disclosureSchemeScotland === 'DS Basic',
                                                onChange: _cache[10] || (_cache[10] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.v$.formData.disclosureSchemeScotland.$touch()))
                                            }, null, 42, _hoisted_39)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_40
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("input", {
                                                id: "radio-button-ds-standard",
                                                name: "disclosureSchemeScotland",
                                                type: "radio",
                                                value: "DS Standard",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.disclosureSchemeScotland === 'DS Standard',
                                                onChange: _cache[12] || (_cache[12] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[13] || (_cache[13] = ($event) => (_ctx.v$.formData.disclosureSchemeScotland.$touch()))
                                            }, null, 42, _hoisted_43)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_44
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("div", _hoisted_46, [
                                            _createElementVNode("input", {
                                                id: "radio-button-ds-enhanced",
                                                name: "disclosureSchemeScotland",
                                                type: "radio",
                                                value: "DS Enhanced",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.disclosureSchemeScotland === 'DS Enhanced',
                                                onChange: _cache[14] || (_cache[14] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[15] || (_cache[15] = ($event) => (_ctx.v$.formData.disclosureSchemeScotland.$touch()))
                                            }, null, 42, _hoisted_47)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_48
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("div", _hoisted_50, [
                                            _createElementVNode("input", {
                                                id: "radio-button-ds-pvg",
                                                name: "disclosureSchemeScotland",
                                                type: "radio",
                                                value: "DS PVG",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.disclosureSchemeScotland === 'DS PVG',
                                                onChange: _cache[16] || (_cache[16] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[17] || (_cache[17] = ($event) => (_ctx.v$.formData.disclosureSchemeScotland.$touch()))
                                            }, null, 42, _hoisted_51)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_52
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ]),
        _createTextVNode(),
        (!_ctx.showApprovalSteps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _createElementVNode("button", {
                    class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                    onClick: _cache[18] || (_cache[18] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.handleResetForm && _ctx.handleResetForm(...args)), ["prevent"]))
                }, "\n        Reset Form\n      "),
                _createTextVNode(),
                _createElementVNode("button", {
                    disabled: _ctx.v$.$invalid || _ctx.uploading,
                    type: "submit",
                    class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                    onClick: _cache[19] || (_cache[19] =
                        //@ts-ignore
                        (...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
                }, "\n        Next\n      ", 8, _hoisted_54)
            ]))
            : _createCommentVNode("", true)
    ]));
}
